import { useEffect } from 'react';
/**
 * @deprecated moved to marketplace-ui-common/hooks
 */

export const useFocusCloseButton = (focused, closeButton) => {
  useEffect(() => {
    if (focused) {
      const focusedElement = closeButton || document.querySelector('[role="button"][data-action="close"]');

      if (focusedElement) {
        focusedElement.focus();
      }
    }
  }, [focused, closeButton]);
};